<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="电销计划"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="900px"
    :modal="false"
  >
    <div class="projectGZJD">
      <el-tabs type="border-card" v-model="activeName" @tab-click="tabChange">
        <el-tab-pane
          v-for="item in ruleList"
          :key="item.nodeId"
          :label="item.title"
          :name="item.nodeId"
        ></el-tab-pane>
      </el-tabs>
      <div class="projectGZJD-choose">
        <el-checkbox
          v-for="item in chooseItem.childList"
          :key="item.subNodeId"
          :label="item.subNodeId"
          :checked="item.subNodeResult == 1 ? true : false"
          @change="(v) => changeNode(v, item)"
          >{{ item.subNodeTitle }}</el-checkbox
        >
      </div>
      <div class="projectGZJD-main">
        <el-row :gutter="10">
          <el-col :span="8">
            <div class="projectGZJD-main-log" style="min-height: 20px;">
              <el-timeline-item
                v-for="log in chooseItem.logList"
                :key="log.id"
                :timestamp="log.operatorTime"
              >
                {{ log.content }}
              </el-timeline-item>
            </div>
          </el-col>
          <el-col :span="16">
            <div
              v-for="item in chooseItem.fileNodeDTOList"
              :key="item.fileNodeId"
              style="margin-bottom: 16px"
            >
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="18">
                  <h3>
                    {{ item.fileNodeTitle }}
                  </h3>
                </el-col>
                <el-col :span="6">
                  <el-upload
                    action="/KYWB/foreign/storage/uploadFile"
                    :headers="headersObj"
                    :file-list="liveImageFileList"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      @click="clickOneUpload(item)"
                      >上传附件</el-button
                    >
                  </el-upload>
                </el-col>
              </el-row>
              <div v-if="item.filePathList" style="margin-top: 16px">
                <el-table
                  :data="item.filePathList"
                  border
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="filePath"
                    label="附件"
                    width="200"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column label=""></el-table-column>
                  <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                      <el-button
                        @click="handleDel(scope.row)"
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <div v-if="chooseItem.messageNodeDTOList" style="margin-top: 16px">
            <el-table
              :data="chooseItem.messageNodeDTOList"
              border
              size="small"
              style="width: 100%"
            >
              <el-table-column
                prop="title"
                label="填写内容"
                width="200"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column label="">
                  <template slot-scope="scope">
                      <el-input v-model="scope.row.value"/>
                  </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="70">
                <template slot-scope="scope">
                  <el-button
                    @click="handleSaveMessage(scope.row)"
                    type="text"
                    size="small"
                    >保存</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"

        @click="handleCancel"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  getProjectDetail,
  saveTelemarketingItem,
  saveTelemarketingMessage,
  addTelemarketingFile,
  deleteTelemarketingFile
} from "@/api/salesManagement/dxjh";
import cookies from "@/libs/util.cookies";
export default {
  data() {
    return {
      chooseItem: {},
      ruleList: [],
      activeName: null,
      checkList: [],
      headersObj: {
        Authorization: "Bearer " + cookies.get("token"),
        appCode: "YHGHT",
      },
      liveImageFileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  props: ["editData"],
  created() {
    this.getProjectDetailFun();
  },
  methods: {
    tabChange(v) {
      const item = this.ruleList.find(
          (item) => item.nodeId === this.activeName
        );
        if (item) {
          this.chooseItem = item;
        }
    },
    clickOneUpload(item) {
      this.fileNode = item;
    },
    handleSuccess(res) {
      if (res && res.data) {
        this.addTelemarketingFileFun(res.data.url);
      }
    },
    async addTelemarketingFileFun(filePath) {
      const res = await addTelemarketingFile({
        projectId: this.editData.projectId,
        filePath,
        fileNodeId: this.fileNode.fileNodeId,
        nodeId: this.chooseItem.nodeId,
        saleTelemarketingPlanId: this.editData.planId,
      });
      if (res.code === 200) {
        this.getProjectDetailFun(true);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    async getProjectDetailFun(need = false) {
      const res = await getProjectDetail({projectId: this.editData.projectId, planId: this.editData.planId});
      if (
        res.code === 200 &&
        res.data &&
        res.data.content &&
        res.data.content.length
      ) {
        this.ruleList = res.data.content;
        if (!need) {
          this.chooseItem = res.data.content[0];
          this.activeName = res.data.content[0].nodeId;
          return;
        }
        const item = res.data.content.find(
          (item) => item.nodeId === this.activeName
        );
        if (item) {
          this.chooseItem = item;
        }
      }
    },
    async handleDel(row) {
      await deleteTelemarketingFile(row);
      this.getProjectDetailFun(true);
    },
    changeNode(row, item) {
      const data = {
        subNodeId: item.subNodeId,
        subNodeResult: row ? 1 : 0,
        projectId: this.editData.projectId,
        nodeId: this.chooseItem.nodeId,
        saleTelemarketingPlanId: this.editData.planId,
      };
      item.subNodeResult = row ? 1 : 0;
      saveTelemarketingItem(data);
    },
    handleSaveMessage(row) {
      const data = {
        messageNodeId: row.messageId,
        messageNodeResult: row.value,
        title: row.title,
        projectId: this.editData.projectId,
        nodeId: this.chooseItem.nodeId,
        saleTelemarketingPlanId: this.editData.planId,
      };

      saveTelemarketingMessage(data);
      this.$message.success("填写成功");
      // this.getProjectDetailFun(true);
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
.projectGZJD {
  &-choose,
  &-main {
    margin-top: 16px;
  }
  .el-upload-list {
    display: none;
  }
  .el-timeline-item {
    list-style-type: none;
  }
}
</style>
<style lang="scss">
.projectGZJD {
  .el-upload-list {
    display: none;
  }
  &-main {
    &-log {
      max-height: 400px;
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/dxjh/components/addDialog.vue